export const STEP_AVAILABILITY = 'availability';
export const STEP_ROOMS = 'rooms';
export const STEP_PRODUCTS = 'products';
export const STEP_CHECKOUT = 'checkout';
export const STEP_SUCCESS = 'success';
